import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import driversReducer from '../slices/driversSlice';
import vehiclesReducer from '../slices/vehiclesSlice';
import ridesReducer from '../slices/ridesSlice';
import shiftsReducer from '../slices/shiftsSlice';
import plannedShiftsReducer from '../slices/plannedShiftsSlice';
import notificationsReducer from '../slices/notificationsSlice';
import customersReducer from '../slices/customersSlice';
import waitTimeReducer from '../slices/waitTimeSlice';
import appDataReducer from '../slices/appDataSlice';
import driverMessagesReducer from '../slices/driverMessagesSlice';
import settingsReducer from '../slices/settingsSlice';
import festpreiseReducer from '../slices/festpreiseSlice';
import sectorsReducer from '../slices/sectorsSlice';
import operatorsReducer from '../slices/operatorsSlice';
import medicalTransportOrdersReducer from '../slices/medicalTransportOrdersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    drivers: driversReducer,
    vehicles: vehiclesReducer,
    rides: ridesReducer,
    shifts: shiftsReducer,
    plannedShifts: plannedShiftsReducer,
    notifications: notificationsReducer,
    customers: customersReducer,
    waitTime: waitTimeReducer,
    appData: appDataReducer,
    driverMessages: driverMessagesReducer,
    settings: settingsReducer,
    festpreise: festpreiseReducer,
    sectors: sectorsReducer,
    operators: operatorsReducer,
    medicalTransportOrders: medicalTransportOrdersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
